export * from '@cipafacil/lib/mock-api/public-api';
